export default __webpack_public_path__ + "static/media/children.99aa9be8.jpg";